import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../../playground/common/auto-form';
import { LIFE_MAX_FIELDS } from './fields';
import { LifeMaxResultView } from './result-view';
import { LifeMaxFormValues, lifeMaxDefaults, lifeMaxSchema } from './schema';
import { buildLifeMaxPayload, simulateLifeMax } from './service';

export function LifeMaxV2Page() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);

  const mutation = useMutation({
    mutationFn: (values: LifeMaxFormValues) => simulateLifeMax(values),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={LIFE_MAX_FIELDS}
            schema={lifeMaxSchema}
            defaults={lifeMaxDefaults}
            isLoading={mutation.isLoading}
            onSubmit={(values) => {
              setLastRequest(buildLifeMaxPayload(values));
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <LifeMaxResultView
          request={lastRequest}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
